'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleCode$() {
  this.c8u = null;
  this.c8v = false;
  this.c8s = null;
  this.c8t = false;
}
export { $c_Lpresto_types$RoleCode$ as $c_Lpresto_types$RoleCode$ };
$p = $c_Lpresto_types$RoleCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleCode$;
/** @constructor */
function $h_Lpresto_types$RoleCode$() {
}
export { $h_Lpresto_types$RoleCode$ as $h_Lpresto_types$RoleCode$ };
$h_Lpresto_types$RoleCode$.prototype = $p;
$p.crE = (function() {
  if ((!this.c8v)) {
    this.c8u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8v = true;
  }
  return this.c8u;
});
$p.kw = (function() {
  if ((!this.c8t)) {
    this.c8s = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c8t = true;
  }
  return this.c8s;
});
var $d_Lpresto_types$RoleCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleCode$, "presto.types$RoleCode$", ({
  a1p: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleCode$ as $d_Lpresto_types$RoleCode$ };
var $n_Lpresto_types$RoleCode$;
function $m_Lpresto_types$RoleCode$() {
  if ((!$n_Lpresto_types$RoleCode$)) {
    $n_Lpresto_types$RoleCode$ = new $c_Lpresto_types$RoleCode$();
  }
  return $n_Lpresto_types$RoleCode$;
}
export { $m_Lpresto_types$RoleCode$ as $m_Lpresto_types$RoleCode$ };
//# sourceMappingURL=presto.types$-Role-Code$.js.map
